import React from "react";
import { observer, inject } from "mobx-react";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { SelectField } from "ComponentsUI/Selectfield";
import { generateUrl } from "Services/withDefaultParams";
import { RangePicker } from "ComponentsUI/Rangepicker";
import Routes from "Configs/routes";
import { withRouter } from "react-router-dom";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import queryString from "query-string";
import orderBy from "lodash/orderBy";
import { FiltersLayout, FiltersItem } from "ComponentsUI/Filters";
import Metrika from "Services/Metrika";
import {
	EVENT_CATEGORY_FILTER_DATA,
	EVENT_CATEGORY_SORT_DATA,
} from "Constants/metriks/GoogleCategorys";
import { FiltersStub } from "Layouts/Stubs";

const SPEED_RANGE_STEP = 10;

@withRouter
@inject("ApplicationModel")
@observer
export default class FiltersContainer extends FiltersLoadParams {
	constructor(props) {
		super(props);
		let text = props.ApplicationModel.text;
		this.state = {
			sort: [
				{
					id: 1,
					key: "order,id",
					name: text.SORT_BY_POP_1,
					down: true,
				},
				{
					id: 2,
					key: "displayPrice,id",
					name: text.SORT_BY_PRICE_2,
					down: true,
				},
				{
					id: 3,
					key: "-displayPrice,id",
					name: text.SORT_BY_PRICE_1,
					up: true,
				},
				{
					id: 4,
					key: "-internet.speed_in,id",
					name: text.SORT_BY_SPEED_1,
					up: true,
				},
			],
			revertSpeed: false,
			showFilters: false,
		};
	}

	componentDidMount() {
		this.props.onMount(this);
	}

	changeSortState(number, string) {
		let sortState = this.state.sort;
		sortState[number].key = string;

		this.setState({ sort: sortState });
	}

	onFilter(filter) {
		const {
			match: { params },
			location: { search },
			history,
		} = this.props;
		const getParams = queryString.parse(search);
		let filterArr = [];
		let selectedTypesOfTariff = [];

		if (!!filter.district) {
			if (!!filter.district.length) {
				getParams.district = filter.district[0].id;
				this.changeSortState(0, "-districtsList,-is_exclusive,order,id");
				if (!getParams.sort) {
					getParams.sort = "-districtsList,-is_exclusive,order,id";
				} else if (getParams.sort === "order,id") {
					getParams.sort = "-districtsList,-is_exclusive,order,id";
				}
			} else {
				getParams.district = null;
				this.changeSortState(0, "order,id");
				if (getParams.sort === "-districtsList,-is_exclusive,order,id") {
					getParams.sort = null;
				}
			}
			// getParams.district = !!filter.district.length
			//     ? filter.district[0].id
			//     : null;
		}

		if (filter.speed) {
			if (
				filter.speed[0].min == this.props.filters.speed[0].min &&
				filter.speed[0].max == this.props.filters.speed[0].max
			) {
				getParams.speed = "";
			} else {
				getParams.speed = `${filter.speed[0].min},${filter.speed[0].max}`;
			}
		}

		if (filter.price) {
			if (
				filter.price[0].min == this.props.filters.price[0].min &&
				filter.price[0].max == this.props.filters.price[0].max
			) {
				getParams.price = "";
			} else {
				getParams.price = `${filter.price[0].min},${filter.price[0].max}`;
			}
		}

		if (filter.tariff) {
			let tariffs = filter.tariff.length > 0 ? orderBy(filter.tariff, "id", "desc") : filter.tariff;
			tariffs.map((item) => {
				selectedTypesOfTariff.push(item.id);
			});
			getParams.tariff = selectedTypesOfTariff.join(",");
		}

		for (let key in getParams) {
			if (getParams[key]) {
				filterArr.push(`${key}=${getParams[key]}`);
			}
		}

		const providersUrl = generateUrl(Routes.ProviderRates.route, {
			regionUrl: params.regionUrl,
			providerName: params.providerName,
		});

		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_FILTER_DATA,
			`filter_data.tariffs.${filterArr.join("&")}`
		);

		history.push({
			pathname: providersUrl,
			search: filterArr.length && !filter.fullReset ? `?${filterArr.join("&")}` : "",
		});
	}

	onResetFilters() {
		const { filters } = this.props;

		this.onFilter({
			dody: [],
			tariff: [],
			speed: filters.speed,
			price: filters.price,
			district: [],
			fullReset: true,
		});
	}

	checkRange(data) {
		if (!data[0]) {
			return false;
		}
		return !!((data[0].min || data[0].min === 0) && data[0].max && data[0].min !== data[0].max);
	}

	onSort(sort) {
		const {
			location: { search },
			history,
		} = this.props;

		const getParams = queryString.parse(search);

		// Вернуть default state, если был прожат сброс фильтра в контейнере с тарифами
		if (!getParams.district && sort[0].key === "-districtsList,-is_exclusive,order,id") {
			this.changeSortState(0, "order,id");
			sort[0].key = "order,id";
		}

		let urlArr = [];

		let activeSort = sort[0];

		if (!!activeSort.key) {
			getParams.sort = activeSort.key;
		} else {
			delete getParams.sort;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		const providerDetailsUrl = generateUrl(Routes.ProviderRates.route, {
			regionUrl: this.props.match.params.regionUrl,
			providerName: this.props.match.params.providerName,
		});

		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_SORT_DATA,
			`sort_data.tariffs.${urlArr.join("&")}`
		);

		history.push({
			pathname: providerDetailsUrl,
			search: urlArr.length ? `?${urlArr.join("&")}` : "",
		});
	}

	render() {
		let {
			ApplicationModel: { text },
			filters,
		} = this.props;

		if (!Object.keys(filters).length) {
			return <FiltersStub amount={3} />;
		}

		let {
			price: priceByFilters,
			speed: speedByFilters,
			types: typesTariffByFilters,
			districts: districtsByFilters,
		} = filters;

		//Скрыть фильтр по услугам
		typesTariffByFilters = [];

		districtsByFilters =
			districtsByFilters.length > 0
				? orderBy(districtsByFilters, "name", "asc")
				: districtsByFilters;

		const priceFinded = this.priceInitFromGetParams(priceByFilters);
		const speedFinded = this.speedInitFromGetParams(speedByFilters);
		const districtFinded = this.districtInitFromGetParams(districtsByFilters);
		let typesTariffFinded = this.typeOfTariffFromGetParams(typesTariffByFilters);
		let typesForFilter = typesTariffByFilters;

		typesForFilter = typesForFilter.map((item) => {
			return { ...item, id: item.key };
		});
		typesForFilter = typesForFilter.filter((item) => {
			return !!item.count;
		});

		typesTariffFinded = typesTariffFinded.map((item) => {
			return { ...item, id: item.key };
		});

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let sortFinded = this.getSortFromParams(this.state.sort);

		let noHiddenFilters;
		let oneHiddenFilter;
		let twoHiddenFilters;

		if (this.props.isProviderCard) {
			let listFilters = [
				!!districtsByFilters.length,
				!!typesForFilter.length,
				this.checkRange(speedByFilters),
				this.checkRange(priceByFilters),
			];

			let countOfHiddenFilters = 0;

			listFilters.map((item) => {
				if (!item) {
					countOfHiddenFilters++;
				}
			});

			if (countOfHiddenFilters === 0) {
				noHiddenFilters = true;
			} else if (countOfHiddenFilters === 1) {
				oneHiddenFilter = true;
			} else if (countOfHiddenFilters === 2) {
				twoHiddenFilters = true;
			}
		}

		return (
			<FiltersLayout
				noHiddenFilters={noHiddenFilters}
				oneHiddenFilter={oneHiddenFilter}
				twoHiddenFilters={twoHiddenFilters}
			>
				<CollapseFiltersContainer
					resetFiltersHandler={() => this.onResetFilters()}
					isProviderCard={this.props.isProviderCard}
					twoHiddenFilters={twoHiddenFilters}
					showResetButtonAfterFilterApply
				>
					{!!districtsByFilters.length && (
						<FiltersItem>
							<SelectField
								multiselect={false}
								allowInput={true}
								isFixedList={windowSizes.xs}
								windowSizes={windowSizes}
								items={districtsByFilters}
								onItemSelect={(items) =>
									this.onFilter({
										district: items,
									})
								}
								title={text.DISTRICT}
								text={text}
								findItems={districtFinded}
								placeholder={text.DISTRICT}
								activePlaceHolder={text.CHOOSE_DISTRICT}
								datatest="providers_input_filter_district"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
							/>
						</FiltersItem>
					)}
					{!!typesForFilter.length && (
						<FiltersItem>
							<SelectField
								activePlaceHolder={text.CHOOSE_A_SERVICES}
								windowSizes={windowSizes}
								isFixedList={windowSizes.xs}
								multiselect={true}
								text={text}
								onlyInputDisabled={true}
								items={typesForFilter}
								onItemSelect={(items) =>
									this.onFilter({
										tariff: items,
									})
								}
								title={text.FILTERS_SERVICE}
								findItems={typesTariffFinded}
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
							/>
						</FiltersItem>
					)}
					{this.checkRange(speedByFilters) && (
						<FiltersItem>
							<RangePicker
								text={text}
								changeFilter={(type, value) => {
									this.onFilter(
										{
											speed: [value],
										},
										speedByFilters
									);
								}}
								onReset={() => {
									this.onFilter({
										speed: speedByFilters,
									});
								}}
								range={{
									min: speedByFilters[0] && speedByFilters[0].min ? speedByFilters[0].min : 0,
									max: speedByFilters[0] && speedByFilters[0].max ? speedByFilters[0].max : 0,
								}}
								value={speedFinded[0]}
								title={text.FILTERS_TYPE_SPEED}
								datatest="providers_provider_input_internetspeed"
								whiteBody={true}
								step={SPEED_RANGE_STEP}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputNameMin="change_speed_min"
								inputNameMax="change_speed_max"
							/>
						</FiltersItem>
					)}
					{this.checkRange(priceByFilters) && (
						<FiltersItem>
							<RangePicker
								text={text}
								changeFilter={(type, value) => {
									this.onFilter(
										{
											price: [value],
										},
										priceByFilters
									);
								}}
								onReset={() => {
									this.onFilter({
										price: priceByFilters,
									});
								}}
								range={{
									min: priceByFilters[0] ? priceByFilters[0].min : 0,
									max: priceByFilters[0] ? priceByFilters[0].max : 0,
								}}
								value={priceFinded[0]}
								datatest="providers_provider_input_priceinmonth"
								title={text.FILTERS_TYPE_PRICE}
								whiteBody={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputNameMin="change_price_min"
								inputNameMax="change_price_max"
							/>
						</FiltersItem>
					)}
					<FiltersItem>
						<SelectField
							multiselect={false}
							windowSizes={windowSizes}
							isFixedList={windowSizes.xs}
							items={this.state.sort}
							onItemSelect={(items) => this.onSort(items)}
							text={text}
							findItems={sortFinded}
							placeholder={text.SORT_BY}
							activePlaceHolder={text.SORT_BY}
							onlyInputDisabled={true}
							withoutClose={true}
							title={text.sorting}
							whiteInput={true}
							onFocus={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
							}}
							onBlur={() => {
								this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
							}}
							inputName="sort_tariffs"
						/>
					</FiltersItem>
				</CollapseFiltersContainer>
			</FiltersLayout>
		);
	}
}
